import { json, type DataFunctionArgs } from '@remix-run/node'
import { Outlet, useLoaderData } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { DocsSidebarNav } from '#app/components/sidebar-nav.tsx'
import { getContentNotes } from '#app/utils/content-notes.server.ts'
import { prisma } from '#app/utils/db.server.ts'

export async function loader({ params }: DataFunctionArgs) {
	const notes = await prisma.note.findMany({
		select: { id: true, title: true, slug: true, category: true },
	})

	if (notes.length === 0) {
		const fallbackNotes = getContentNotes().map(note => ({
			id: note.slug,
			title: note.title,
			slug: note.slug,
			category: note.category,
		}))
		return json({ notes: fallbackNotes })
	}

	//console.log(notes)
	return json({ notes })
}

export default function NotesRoute() {
	const data = useLoaderData<typeof loader>()
	return (
		<div className="flex-1 md:grid md:grid-cols-[220px_1fr] md:gap-6 lg:grid-cols-[240px_1fr] lg:gap-10">
			<aside className="fixed top-14 z-30 hidden  h-[calc(100vh-3.5rem)] w-full shrink-0 overflow-y-auto border-r py-6 pr-2 md:sticky md:block lg:py-10">
				<DocsSidebarNav items={data?.notes} />
			</aside>
			<Outlet />
		</div>
	)
}

export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: ({ params }) => <p>No existe esta página</p>,
			}}
		/>
	)
}
